import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { HttpClient } from "@angular/common/http";
import { createRequestAction, RequestState } from "ngxs-requests-plugin";
import { environment } from "../../../../environments/environment";
import { IVariable } from "../../interfaces/variable.interface";
import { GetVariableSubtree, GetVariableSubtreeFail, GetVariableSubtreeSuccess, ResetVariableSubtree, SearchSubtreeVariable, SearchSubtreeVariableFail, SearchSubtreeVariableSuccess } from "./variables-subtrees.actions";

export interface VariablesSubtreesStateModel {
  subtree: IVariable
}

@RequestState('getVariableSubtree')
@Injectable()
export class GetVariableSubtreeRequestState {
}

@RequestState('searchSubtreeVariable')
@Injectable()
export class SearchSubtreeVariableRequestState {
}

@State<VariablesSubtreesStateModel>({
  name: 'variablesSubtrees',
  defaults: {
    subtree: null
  }
})
@Injectable()
export class VariablesSubtreesState {
  constructor(
    private http: HttpClient,
  ) {}

  @Action(GetVariableSubtree)
  getVariableSubtree(
    { dispatch }: StateContext<VariablesSubtreesStateModel>,
    { payload: filterTreeName }: GetVariableSubtree
  ) {
    const request = this.http.get(environment.api + 'db/meta/values/tree/' + filterTreeName);

    return dispatch(
      createRequestAction({
        request,
        state: GetVariableSubtreeRequestState,
        successAction: GetVariableSubtreeSuccess,
        failAction: GetVariableSubtreeFail,
      })
    );
  }

  @Action(GetVariableSubtreeSuccess)
  getVariableSubtreeSuccess(
    { patchState }: StateContext<VariablesSubtreesStateModel>,
    { payload: response }: GetVariableSubtreeSuccess
  ) {
    patchState({subtree: response.content});
  }

  @Action(ResetVariableSubtree)
  resetVariableSubtree(
    { patchState }: StateContext<VariablesSubtreesStateModel>
  ) {
    patchState({subtree: null});
  }


  @Action(SearchSubtreeVariable)
  searchSubtreeVariable(
    { dispatch }: StateContext<VariablesSubtreesStateModel>,
    { payload: {filterTreeName, input} }: SearchSubtreeVariable
  ) {
    const request = this.http.get(environment.api + 'search/tree/' + filterTreeName + '/' + input);

    return dispatch(
      createRequestAction({
        request,
        state: SearchSubtreeVariableRequestState,
        successAction: SearchSubtreeVariableSuccess,
        failAction: SearchSubtreeVariableFail,
      })
    );
  }

  @Action(SearchSubtreeVariableSuccess)
  searchSubtreeVariableSuccess(
    ctx: StateContext<VariablesSubtreesStateModel>,
    { payload: response}: SearchSubtreeVariableSuccess
  ) {
    console.debug(response);
    
  }
}